module.exports = __webpack_public_path__ + "static/media/periscope.6ba7de63.svg";